import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <p className="text-sm text-gray-400 mb-4">
              A life worth living is a life worth funding. Transform your life with our comprehensive 
              assessment tools and AI-powered coaching.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/lifeworthfunding/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-green-500 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-green-500 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-green-500 transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-green-500 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-green-500 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/assessment" className="hover:text-green-500 transition-colors">
                  Assessment
                </Link>
              </li>
              <li>
                <Link to="/customize" className="hover:text-green-500 transition-colors">
                  Customize
                </Link>
              </li>
              <li>
                <Link to="/coaching" className="hover:text-green-500 transition-colors">
                  Coaching Tools
                </Link>
              </li>
              <li>
                <Link to="/premium" className="hover:text-green-500 transition-colors">
                  Premium
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                <a 
                  href="mailto:gsloancastellanos@gmail.com" 
                  className="hover:text-green-500 transition-colors"
                >
                  gsloancastellanos@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                <a 
                  href="https://wa.me/13522552601" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-green-500 transition-colors"
                >
                  +1 352 255-2601 (WhatsApp)<br />
                  <span className="text-xs text-gray-400">Text messages only, please</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} Life Worth Funding. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
            <Link to="/privacy" className="hover:text-green-500 transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-green-500 transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
